import { Box, Typography } from "@mui/material";
import fondo from "../../static/media/AboutUs/banner.webp";
import { motion } from "framer-motion";

const MotionBox = motion(Box);
const MotionTypography = motion(Typography);

export default function AboutMotivationBanner() {
  return (
    <MotionBox
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-120px" }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      sx={{
        width: "100%",
        height: { xs: "40vh", md: "70vh" },
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <MotionBox
        component="img"
        src={fondo}
        alt="Comunidad NovaXFit entrenando juntos"
        initial={{ scale: 1.08, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, ease: "easeOut" }}
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      <MotionBox
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: "easeOut", delay: 0.15 }}
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.40) 0%, rgba(0,0,0,0.60) 55%, rgba(0,0,0,0.80) 100%)",
        }}
      />

      <MotionTypography
        initial={{ opacity: 0, y: 40, filter: "blur(8px)" }}
        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: "easeOut", delay: 0.35 }}
        sx={{
          position: "relative",
          textAlign: "center",
          px: 3,
          fontSize: {
            xs: "clamp(34px,6vw,44px)",
            md: "clamp(48px,4vw,64px)",
          },
          lineHeight: 1.05,
          fontWeight: 750,
          letterSpacing: "-0.02em",
          color: "#ffffff",
          textShadow: "0 12px 40px rgba(0,0,0,0.7)",
          maxWidth: { xs: "none", md: "850px" },
        }}
      >
        En{" "}
        <Box component="span" sx={{ color: "#e50914" }}>
          NovaXFit
        </Box>
        , no solo vienes a entrenar. Vienes a crecer, a superarte y a formar
        parte de una comunidad que impulsa tu mejor versión.
      </MotionTypography>
    </MotionBox>
  );
}